module.exports = __webpack_public_path__ + "static/64gde-8eda58cf7187d78a41cf4542c69fbebe.gif";